import React from 'react';
import './SkipLink.css';

/**
 * Skip Link component for keyboard navigation accessibility (WCAG 2.4.1)
 * Allows keyboard users to skip repetitive navigation and jump to main content
 */
const SkipLink: React.FC = () => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView();
    }
  };

  return (
    <a
      href="#main-content"
      className="skip-link"
      onClick={handleClick}
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;
